import styles from "./Logo.module.scss";
import logo from "./logo.png";
import cx from "classnames";

export const Logo: React.FC<{ className?: string; onClick?: () => void }> = ({
  className,
  onClick,
}) => {
  return (
    <div className={cx(styles.wrapper, className)} onClick={onClick}>
      <img src={logo} draggable={false} className={styles.img} />
    </div>
  );
};
